export default __webpack_public_path__ + "static/articulo6-8dea330a3bb9dc57aca164c2b116ff72.png";